export default {
  sklopovi_a: {
    _1_1: require("../src/assets/images/sklopovi/1.1.A.png"),
    _1_10: require("../src/assets/images/sklopovi/1.10.A.png"),
    _1_11: require("../src/assets/images/sklopovi/1.11.A.png"),
    _1_12: require("../src/assets/images/sklopovi/1.12.A.png"),
    _1_13: require("../src/assets/images/sklopovi/1.13.A.png"),
    _1_14: require("../src/assets/images/sklopovi/1.14.A.png"),
    _1_15: require("../src/assets/images/sklopovi/1.15.A.png"),
    _1_16: require("../src/assets/images/sklopovi/1.16.A.png"),
    _1_17: require("../src/assets/images/sklopovi/1.17.A.png"),
    _1_18: require("../src/assets/images/sklopovi/1.18.A.png"),
    _1_19: require("../src/assets/images/sklopovi/1.19.A.png"),
    _1_2: require("../src/assets/images/sklopovi/1.2.A.png"),
    _1_20: require("../src/assets/images/sklopovi/1.20.A.png"),
    _1_3: require("../src/assets/images/sklopovi/1.3.A.png"),
    _1_4: require("../src/assets/images/sklopovi/1.4.A.png"),
    _1_5: require("../src/assets/images/sklopovi/1.5.A.png"),
    _1_6: require("../src/assets/images/sklopovi/1.6.A.png"),
    _1_7: require("../src/assets/images/sklopovi/1.7.A.png"),
    _1_8: require("../src/assets/images/sklopovi/1.8.A.png"),
    _1_9: require("../src/assets/images/sklopovi/1.9.A.png"),
    _18_1: require("../src/assets/images/sklopovi/18.1.A.png"),
    _18_101: require("../src/assets/images/sklopovi/18.101.A.png"),
    _18_102: require("../src/assets/images/sklopovi/18.102.A.png"),
    _18_103: require("../src/assets/images/sklopovi/18.103.A.png"),
    _18_104: require("../src/assets/images/sklopovi/18.104.A.png"),
    _18_105: require("../src/assets/images/sklopovi/18.105.A.png"),
    _18_106: require("../src/assets/images/sklopovi/18.106.A.png"),
    _18_107: require("../src/assets/images/sklopovi/18.107.A.png"),
    _18_108: require("../src/assets/images/sklopovi/18.108.A.png"),
    _18_2: require("../src/assets/images/sklopovi/18.2.A.png"),
    _18_3: require("../src/assets/images/sklopovi/18.3.A.png"),
    _18_4: require("../src/assets/images/sklopovi/18.4.A.png"),
    _18_5: require("../src/assets/images/sklopovi/18.5.A.png"),
    _18_6: require("../src/assets/images/sklopovi/18.6.A.png"),
    _18_7: require("../src/assets/images/sklopovi/18.7.A.png"),
    _18_8: require("../src/assets/images/sklopovi/18.8.A.png"),
    _19_1: require("../src/assets/images/sklopovi/19.1.A.png"),
    _19_10: require("../src/assets/images/sklopovi/19.10.A.png"),
    _19_11: require("../src/assets/images/sklopovi/19.11.A.png"),
    _19_2: require("../src/assets/images/sklopovi/19.2.A.png"),
    _19_3: require("../src/assets/images/sklopovi/19.3.A.png"),
    _19_4: require("../src/assets/images/sklopovi/19.4.A.png"),
    _19_5: require("../src/assets/images/sklopovi/19.5.A.png"),
    _19_6: require("../src/assets/images/sklopovi/19.6.A.png"),
    _19_7: require("../src/assets/images/sklopovi/19.7.A.png"),
    _19_8: require("../src/assets/images/sklopovi/19.8.A.png"),
    _19_9: require("../src/assets/images/sklopovi/19.9.A.png"),
    _20_1: require("../src/assets/images/sklopovi/20.1.A.png"),
    _20_2: require("../src/assets/images/sklopovi/20.2.A.png"),
    _20_3: require("../src/assets/images/sklopovi/20.3.A.png"),
    _20_4: require("../src/assets/images/sklopovi/20.4.A.png"),
    _21_1: require("../src/assets/images/sklopovi/21.1.A.png"),
    _21_2: require("../src/assets/images/sklopovi/21.2.A.png"),
    _21_3: require("../src/assets/images/sklopovi/21.3.A.png"),
    _21_4: require("../src/assets/images/sklopovi/21.4.A.png"),
    _5_1: require("../src/assets/images/sklopovi/5.1.A.png"),
    _5_2: require("../src/assets/images/sklopovi/5.2.A.png"),
    _5_3: require("../src/assets/images/sklopovi/5.3.A.png"),
    _5_4: require("../src/assets/images/sklopovi/5.4.A.png"),
    _5_5: require("../src/assets/images/sklopovi/5.5.A.png"),
    _5_6: require("../src/assets/images/sklopovi/5.6.A.png"),
    _7_1: require("../src/assets/images/sklopovi/7.1.A.png"),
    _7_2: require("../src/assets/images/sklopovi/7.2.A.png"),
    _7_3: require("../src/assets/images/sklopovi/7.3.A.png"),
    _7_4: require("../src/assets/images/sklopovi/7.4.A.png"),
    _7_5: require("../src/assets/images/sklopovi/7.5.A.png"),
    _7_6: require("../src/assets/images/sklopovi/7.6.A.png"),
  },
  sklopovi_b: {
    _1_1: require("../src/assets/images/sklopovi/1.1.B.png"),
    _1_10: require("../src/assets/images/sklopovi/1.10.B.png"),
    _1_12: require("../src/assets/images/sklopovi/1.12.B.png"),
    _1_13: require("../src/assets/images/sklopovi/1.13.B.png"),
    _1_14: require("../src/assets/images/sklopovi/1.14.B.png"),
    _1_15: require("../src/assets/images/sklopovi/1.15.B.png"),
    _1_16: require("../src/assets/images/sklopovi/1.16.B.png"),
    _1_17: require("../src/assets/images/sklopovi/1.17.B.png"),
    _1_18: require("../src/assets/images/sklopovi/1.18.B.png"),
    _1_19: require("../src/assets/images/sklopovi/1.19.B.png"),
    _1_2: require("../src/assets/images/sklopovi/1.2.B.png"),
    _1_20: require("../src/assets/images/sklopovi/1.20.B.png"),
    _1_3: require("../src/assets/images/sklopovi/1.3.B.png"),
    _1_4: require("../src/assets/images/sklopovi/1.4.B.png"),
    _1_5: require("../src/assets/images/sklopovi/1.5.B.png"),
    _1_6: require("../src/assets/images/sklopovi/1.6.B.png"),
    _1_7: require("../src/assets/images/sklopovi/1.7.B.png"),
    _1_8: require("../src/assets/images/sklopovi/1.8.B.png"),
    _1_9: require("../src/assets/images/sklopovi/1.9.B.png"),
    _18_1: require("../src/assets/images/sklopovi/18.1.B.png"),
    _18_101: require("../src/assets/images/sklopovi/18.101.B.png"),
    _18_102: require("../src/assets/images/sklopovi/18.102.B.png"),
    _18_103: require("../src/assets/images/sklopovi/18.103.B.png"),
    _18_104: require("../src/assets/images/sklopovi/18.104.B.png"),
    _18_105: require("../src/assets/images/sklopovi/18.105.B.png"),
    _18_106: require("../src/assets/images/sklopovi/18.106.B.png"),
    _18_107: require("../src/assets/images/sklopovi/18.107.B.png"),
    _18_108: require("../src/assets/images/sklopovi/18.108.B.png"),
    _18_2: require("../src/assets/images/sklopovi/18.2.B.png"),
    _18_3: require("../src/assets/images/sklopovi/18.3.B.png"),
    _18_4: require("../src/assets/images/sklopovi/18.4.B.png"),
    _18_5: require("../src/assets/images/sklopovi/18.5.B.png"),
    _18_6: require("../src/assets/images/sklopovi/18.6.B.png"),
    _18_7: require("../src/assets/images/sklopovi/18.7.B.png"),
    _18_8: require("../src/assets/images/sklopovi/18.8.B.png"),
    _19_1: require("../src/assets/images/sklopovi/19.1.B.png"),
    _19_10: require("../src/assets/images/sklopovi/19.10.B.png"),
    _19_11: require("../src/assets/images/sklopovi/19.11.B.png"),
    _19_2: require("../src/assets/images/sklopovi/19.2.B.png"),
    _19_3: require("../src/assets/images/sklopovi/19.3.B.png"),
    _19_4: require("../src/assets/images/sklopovi/19.4.B.png"),
    _19_5: require("../src/assets/images/sklopovi/19.5.B.png"),
    _19_6: require("../src/assets/images/sklopovi/19.6.B.png"),
    _19_7: require("../src/assets/images/sklopovi/19.7.B.png"),
    _19_8: require("../src/assets/images/sklopovi/19.8.B.png"),
    _19_9: require("../src/assets/images/sklopovi/19.9.B.png"),
    _5_1: require("../src/assets/images/sklopovi/5.1.B.png"),
    _5_2: require("../src/assets/images/sklopovi/5.2.B.png"),
    _5_3: require("../src/assets/images/sklopovi/5.3.B.png"),
    _5_4: require("../src/assets/images/sklopovi/5.4.B.png"),
    _5_5: require("../src/assets/images/sklopovi/5.5.B.png"),
    _5_6: require("../src/assets/images/sklopovi/5.6.B.png"),
    _7_1: require("../src/assets/images/sklopovi/7.1.B.png"),
    _7_2: require("../src/assets/images/sklopovi/7.2.B.png"),
    _7_3: require("../src/assets/images/sklopovi/7.3.B.png"),
    _7_4: require("../src/assets/images/sklopovi/7.4.B.png"),
    _7_5: require("../src/assets/images/sklopovi/7.5.B.png"),
    _7_6: require("../src/assets/images/sklopovi/7.6.B.png"),
  },
  sklopovi_c: {
    _1_1: require("../src/assets/images/sklopovi/1.1.C.png"),
    _1_10: require("../src/assets/images/sklopovi/1.10.C.png"),
    _1_11: require("../src/assets/images/sklopovi/1.11.C.png"),
    _1_12: require("../src/assets/images/sklopovi/1.12.C.png"),
    _1_13: require("../src/assets/images/sklopovi/1.13.C.png"),
    _1_14: require("../src/assets/images/sklopovi/1.14.C.png"),
    _1_15: require("../src/assets/images/sklopovi/1.15.C.png"),
    _1_16: require("../src/assets/images/sklopovi/1.16.C.png"),
    _1_17: require("../src/assets/images/sklopovi/1.17.C.png"),
    _1_18: require("../src/assets/images/sklopovi/1.18.C.png"),
    _1_19: require("../src/assets/images/sklopovi/1.19.C.png"),
    _1_2: require("../src/assets/images/sklopovi/1.2.C.png"),
    _1_20: require("../src/assets/images/sklopovi/1.20.C.png"),
    _1_3: require("../src/assets/images/sklopovi/1.3.C.png"),
    _1_4: require("../src/assets/images/sklopovi/1.4.C.png"),
    _1_5: require("../src/assets/images/sklopovi/1.5.C.png"),
    _1_6: require("../src/assets/images/sklopovi/1.6.C.png"),
    _1_7: require("../src/assets/images/sklopovi/1.7.C.png"),
    _1_8: require("../src/assets/images/sklopovi/1.8.C.png"),
    _1_9: require("../src/assets/images/sklopovi/1.9.C.png"),
    _18_1: require("../src/assets/images/sklopovi/18.1.C.png"),
    _18_101: require("../src/assets/images/sklopovi/18.101.C.png"),
    _18_102: require("../src/assets/images/sklopovi/18.102.C.png"),
    _18_103: require("../src/assets/images/sklopovi/18.103.C.png"),
    _18_104: require("../src/assets/images/sklopovi/18.104.C.png"),
    _18_105: require("../src/assets/images/sklopovi/18.105.C.png"),
    _18_106: require("../src/assets/images/sklopovi/18.106.C.png"),
    _18_107: require("../src/assets/images/sklopovi/18.107.C.png"),
    _18_108: require("../src/assets/images/sklopovi/18.108.C.png"),
    _18_2: require("../src/assets/images/sklopovi/18.2.C.png"),
    _18_3: require("../src/assets/images/sklopovi/18.3.C.png"),
    _18_4: require("../src/assets/images/sklopovi/18.4.C.png"),
    _18_5: require("../src/assets/images/sklopovi/18.5.C.png"),
    _18_6: require("../src/assets/images/sklopovi/18.6.C.png"),
    _18_7: require("../src/assets/images/sklopovi/18.7.C.png"),
    _18_8: require("../src/assets/images/sklopovi/18.8.C.png"),
    _19_1: require("../src/assets/images/sklopovi/19.1.C.png"),
    _19_10: require("../src/assets/images/sklopovi/19.10.C.png"),
    _19_11: require("../src/assets/images/sklopovi/19.11.C.png"),
    _19_2: require("../src/assets/images/sklopovi/19.2.C.png"),
    _19_3: require("../src/assets/images/sklopovi/19.3.C.png"),
    _19_4: require("../src/assets/images/sklopovi/19.4.C.png"),
    _19_5: require("../src/assets/images/sklopovi/19.5.C.png"),
    _19_6: require("../src/assets/images/sklopovi/19.6.C.png"),
    _19_7: require("../src/assets/images/sklopovi/19.7.C.png"),
    _19_8: require("../src/assets/images/sklopovi/19.8.C.png"),
    _19_9: require("../src/assets/images/sklopovi/19.9.C.png"),
    _20_1: require("../src/assets/images/sklopovi/20.1.C.png"),
    _20_2: require("../src/assets/images/sklopovi/20.2.C.png"),
    _20_3: require("../src/assets/images/sklopovi/20.3.C.png"),
    _20_4: require("../src/assets/images/sklopovi/20.4.C.png"),
    _21_1: require("../src/assets/images/sklopovi/21.1.C.png"),
    _21_2: require("../src/assets/images/sklopovi/21.2.C.png"),
    _21_3: require("../src/assets/images/sklopovi/21.3.C.png"),
    _21_4: require("../src/assets/images/sklopovi/21.4.C.png"),
    _5_1: require("../src/assets/images/sklopovi/5.1.C.png"),
    _5_2: require("../src/assets/images/sklopovi/5.2.C.png"),
    _5_3: require("../src/assets/images/sklopovi/5.3.C.png"),
    _5_4: require("../src/assets/images/sklopovi/5.4.C.png"),
    _5_5: require("../src/assets/images/sklopovi/5.5.C.png"),
    _5_6: require("../src/assets/images/sklopovi/5.6.C.png"),
    _7_1: require("../src/assets/images/sklopovi/7.1.C.png"),
    _7_2: require("../src/assets/images/sklopovi/7.2.C.png"),
    _7_3: require("../src/assets/images/sklopovi/7.3.C.png"),
    _7_4: require("../src/assets/images/sklopovi/7.4.C.png"),
    _7_5: require("../src/assets/images/sklopovi/7.5.C.png"),
    _7_6: require("../src/assets/images/sklopovi/7.6.C.png"),
  },
};
